import { NotImplementedError } from "../../../../errors";
import { parseDateFilter } from "../../../../models/looker/modules/overview";
import { PromiseHandler } from "../../../../handlers";
import { GEO_MAP_ZCTA_QUERY } from "./query";
const toMetric = (value) => typeof value === "number" && Number.isFinite(value) ? value : null;
/**
 * Typed handler for the Overview Geo Targeting map's ZIP (ZCTA) choropleth.
 * Returns true per-ZIP totals grouped by postal, so the fill/popup are accurate
 * regardless of the point-level row cap. Shares the GeoMap filter shape and the
 * same fail-closed advertiser/campaign scoping.
 */
export default class LookerOverviewGeoZcta extends PromiseHandler {
    constructor(sdk) {
        super(sdk, "looker-overview-geo-zcta");
    }
    async findItems(filters) {
        const dateFilter = filters.where?.find((filter) => filter.field === "dates");
        if (!dateFilter) {
            throw new Error("Dates filter is required");
        }
        const queryBody = {
            ...GEO_MAP_ZCTA_QUERY,
            filters: {
                "explore_overview.flt_date_range": parseDateFilter(dateFilter)
            }
        };
        const lookbackFilter = filters.where?.find((filter) => filter.field === "lookbackDays");
        if (lookbackFilter?.value !== undefined && lookbackFilter.value !== null) {
            queryBody.filters["explore_overview.pmt_lookback_window"] = String(lookbackFilter.value);
        }
        const mediaTypeFilter = filters.where?.find((filter) => filter.field === "mediaType");
        const mediaType = mediaTypeFilter?.value;
        if (mediaType && mediaType.length) {
            queryBody.filters["explore_overview.product_group"] = Array.isArray(mediaType)
                ? mediaType.join(",")
                : mediaType;
        }
        const retargetingFilter = filters.where?.find((filter) => filter.field === "retargeting");
        if (retargetingFilter?.value === true) {
            queryBody.filters["adgroup_rtg_by_inst.is_retargeting"] = "Yes";
        }
        // Fail closed: scoped exclusively by advertiser + campaign (matches GeoMap).
        const advertiserFilter = filters.where?.find((filter) => filter.field === "advertiserIds");
        const advertiserIds = advertiserFilter?.value;
        if (!advertiserIds?.length) {
            throw new Error("Advertiser ids filter is required");
        }
        queryBody.filters["advertisers.advertiser_id"] = advertiserIds.join(",");
        const campaignFilter = filters.where?.find((filter) => filter.field === "campaignIds");
        const campaignIds = campaignFilter?.value;
        if (!campaignIds?.length) {
            throw new Error("Campaign ids filter is required");
        }
        queryBody.filters["campaigns.campaign_id"] = campaignIds.join(",");
        const hashKey = await this.sdk.looker.query.hashQuery(queryBody);
        return this.cache.promise(hashKey, () => this.sdk.looker.query
            .run(queryBody)
            .then(({ data, queryMeta }) => [
            {
                data: this.formatResponse(data),
                queryMeta
            }
        ])
            .catch((e) => {
            console.error(e);
            throw new Error("Failed to fetch overview dashboard geo zcta");
        }));
    }
    formatResponse(data) {
        return data
            .map((row) => {
            const postal = row["explore_overview.postal"];
            if (typeof postal !== "string" || postal === "") {
                return null;
            }
            return {
                postal,
                impressions: toMetric(row["explore_overview.total_impressions"]),
                clicks: toMetric(row["explore_overview.total_clicks"])
            };
        })
            .filter((row) => row !== null);
    }
    async saveItem() {
        throw new NotImplementedError("saveItem");
    }
    async deleteItem() {
        throw new NotImplementedError("deleteItem");
    }
}
//# sourceMappingURL=GeoZcta.js.map